import { render, staticRenderFns } from "./Vulnerability.vue?vue&type=template&id=619fd5c4&"
import script from "./Vulnerability.vue?vue&type=script&lang=js&"
export * from "./Vulnerability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports